import React from 'react'
import { Tooltip } from '@chegg-ui/tooltip'
import { AppState } from '@chegg-wt/core/state/types'
import { connect } from 'react-redux'
import { enableFoldersSelector } from '@chegg-wt/core/state/app/selectors'
import { ProjectItemMenuProps } from './types'
import * as Styled from './styled'
import {
  PROJECT_ITEM_MENU,
  PROJECT_ITEM_MENU_MOVE,
  PROJECT_ITEM_MENU_DELETE,
  PROJECT_ITEM_MENU_EDIT,
} from './testIds'

export const ProjectItemMenu: React.FunctionComponent<ProjectItemMenuProps> = ({
  onDelete,
  onEdit,
  hideEdit,
  onMove,
  enableFolders,
}) => (
  <Styled.ProjectItemMenu data-test={PROJECT_ITEM_MENU}>
    {enableFolders && (
      <Styled.MoveIconContainer>
        <Tooltip
          position="top"
          targetElement={
            <Styled.IconButton
              screenReaderOnlyText="move button"
              size="small"
              disableHoverAnimation
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault()
                onMove(e)
              }}
              data-test={PROJECT_ITEM_MENU_MOVE}
            >
              <Styled.MoveIcon />
            </Styled.IconButton>
          }
        >
          <Styled.ToolTipText>Move</Styled.ToolTipText>
        </Tooltip>
      </Styled.MoveIconContainer>
    )}
    <Styled.IconContainer>
      <Tooltip
        position="top"
        targetElement={
          <Styled.IconButton
            screenReaderOnlyText="delete button"
            size="small"
            disableHoverAnimation
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault()
              onDelete(e)
            }}
            data-test={PROJECT_ITEM_MENU_DELETE}
          >
            <Styled.TrashIcon />
          </Styled.IconButton>
        }
      >
        <Styled.ToolTipText>Delete</Styled.ToolTipText>
      </Tooltip>
    </Styled.IconContainer>
    {!hideEdit && (
      <Styled.IconContainer>
        <Tooltip
          position="top"
          targetElement={
            <Styled.IconButton
              screenReaderOnlyText="edit button"
              size="small"
              disableHoverAnimation
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                e.preventDefault()
                onEdit()
              }}
              data-test={PROJECT_ITEM_MENU_EDIT}
            >
              <Styled.EditIcon />
            </Styled.IconButton>
          }
        >
          <Styled.ToolTipText>Edit</Styled.ToolTipText>
        </Tooltip>
      </Styled.IconContainer>
    )}
  </Styled.ProjectItemMenu>
)

const mapStateToProps = (state: AppState) => ({
  enableFolders: enableFoldersSelector(state),
})

export default connect(mapStateToProps)(ProjectItemMenu)
